export function isReviewTrackersCreated (results) {
  return !results.is_whitelabel && results.is_internal
}
